export const CATEGORIAS = ['Penetración <30%', 'Sin operar +3M', 'Nunca operó'];

export const RESULTADOS_GESTION = [
  'Levanta requerimiento para operar',
  'No le interesa, se propone excluir de campaña.',
  'Sin respuesta',
  'Volver a llamar',
];

export const BENEFICIOS = ['Precio', 'Rápidez', 'Riesgo', 'Otros'];

export const fmtMM = (n) => {
  const v = Number(n || 0) / 1_000_000;
  return `$${v.toLocaleString('es-CL', { maximumFractionDigits: 1 })} MM`;
};

export const pillClass = (stage) => {
  if (['Cursado', 'Aprobado', 'aprobada'].includes(stage)) return 'bg-green-100 text-green-800';
  if (['Por aprobar', 'Compromiso vigente', 'Requiere ajustes', 'pendiente', 'ajustes'].includes(stage)) {
    return 'bg-amber-100 text-amber-800';
  }
  if (['Exclusión propuesta', 'Rechazado', 'rechazada'].includes(stage)) return 'bg-red-100 text-red-800';
  return 'bg-slate-100 text-slate-700';
};

export const unwrap = (result) => {
  if (!result) return {};
  if (typeof result.body === 'string') {
    try {
      return JSON.parse(result.body);
    } catch {
      return {};
    }
  }
  if (result.body && typeof result.body === 'object') return result.body;
  return result;
};
